<template>
  <c-box :mx="{ base: '-30px', md: '0' }">
    <ViewOrderDetailsBox :order="cartToOrder(storeCart)" />
  </c-box>
</template>

<script lang="ts">
import { CBox } from "@chakra-ui/vue";
import { defineComponent, PropType } from "vue";
import { mapState } from "vuex";
import ViewOrderDetailsBox from "../ViewOrderDetailsBox.vue";
import { IRootState, ICartState } from "@iloq/shared";
import { IPartnerInfoState } from "@/store/partnerInfoModule";

// Convert class component to regular Vue 2 component
export default defineComponent({
  name: "OrderingConfirmation",
  components: {
    ViewOrderDetailsBox,
    CBox,
  },
  computed: {
    ...mapState("partnerInfo", {
      deliveryTypes: (state: unknown) => (state as IPartnerInfoState).deliveryTypes,
    }),
    ...mapState({
      storeCart: (state: unknown) => (state as IRootState).shoppingCart,
    }),
  },
  props: {
    cart: Object as PropType<ICartState>,
    errors: Array as PropType<any[]>,
  },
  methods: {
    cartToOrder(cart?: ICartState) {
      const { cartRows, ...rest } = (cart || this.cart)!;
      return {
        ...rest,
        rows: cartRows,
      };
    },
  },
  mounted() {
    if (this.errors?.length) {
      this.$router.replace({
        query: {
          step: "3",
        },
      });
    }
  },
});
</script>
